"use client";

import Input from "@client/components/formik/input";
import Fieldset from "@client/components/lead-form/components/fieldset";
import { setUserInteractionDataAttribute } from "@shared/constants";
import kebabToCamelCase from "@shared/functions/kebabToCamelCase";

import type { CommonTileProps } from "@ui/js/components/tiles/common-tile-resources";
import { Tile } from "@ui/js/components/tiles/tile";
import { useFormikContext } from "formik";

const INPUT_ID_AND_LABEL_HTMLFOR = "credit-score";
const FIELD_NAME_SELECTOR = kebabToCamelCase(INPUT_ID_AND_LABEL_HTMLFOR);

export default function CreditScore({
	colorOverride,
	styleOverride,
}: {
	colorOverride?: CommonTileProps["color"];
	styleOverride?: CommonTileProps["componentStyle"];
}) {
	const { setFieldValue } = useFormikContext();

	const handleClick = (e: any) => {
		setFieldValue(FIELD_NAME_SELECTOR, e.currentTarget.value);
	};

	return (
		<Fieldset legend="What is your estimated credit score?">
			<Input
				type="hidden"
				name={FIELD_NAME_SELECTOR}
				id={INPUT_ID_AND_LABEL_HTMLFOR}
			/>
			<Tile
				{...setUserInteractionDataAttribute(
					`lead-form__${INPUT_ID_AND_LABEL_HTMLFOR}__Excellent`,
				)}
				color={colorOverride}
				componentStyle={styleOverride}
				label="Excellent 720-850"
				value="excellent"
				onClick={handleClick}
			/>
			<Tile
				{...setUserInteractionDataAttribute(
					`lead-form__${INPUT_ID_AND_LABEL_HTMLFOR}__Good`,
				)}
				color={colorOverride}
				componentStyle={styleOverride}
				label="Good 680-719"
				value="good"
				onClick={handleClick}
			/>
			<Tile
				{...setUserInteractionDataAttribute(
					`lead-form__${INPUT_ID_AND_LABEL_HTMLFOR}__Fair`,
				)}
				color={colorOverride}
				componentStyle={styleOverride}
				label="Fair 640-679"
				value="fair"
				onClick={handleClick}
			/>
			<Tile
				{...setUserInteractionDataAttribute(
					`lead-form__${INPUT_ID_AND_LABEL_HTMLFOR}__Poor`,
				)}
				color={colorOverride}
				componentStyle={styleOverride}
				label="Poor 0 - 639"
				value="poor"
				onClick={handleClick}
			/>
		</Fieldset>
	);
}
